var URLSearchParams = require('url-search-params')

export const signInUri = path => {
  const queryParams = new URLSearchParams()
  queryParams.set('return_to', path)

  return `${process.env.REACT_APP_OAUTH_REDIRECT_URI}?${queryParams}`
}



// WEBPACK FOOTER //
// ./src/utils/unifiedLogin.js